/* src/app/components/shared/customer-type-carousel/customer-type-carousel.component.scss */
.user-type-select-btn {
  padding: 9px;
  display: block;
  font-size: 11px;
  letter-spacing: 0;
  color: #fff;
  opacity: 0.7;
  border: none;
  position: absolute;
  width: calc(100% - 40px);
  bottom: 17px;
  line-height: 15px;
}
.user-type-box .user-type-wrapper .user-types .user-type-detail {
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.07px;
  color: #3b4e60;
}
.user-type-heading {
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.4px;
  color: #3b4e60;
}
#status-user-type-1 {
  -ms-flex-order: 1;
  order: 1;
}
.user-type {
  -ms-flex-order: 10;
  order: 10;
  height: auto;
  min-height: 245px;
  opacity: 1;
  background: #fff 0 0 no-repeat padding-box;
  border: none !important;
  padding: 17px !important;
  position: relative;
  margin-right: 10px !important;
}
.user-types {
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex: 1;
  flex: 1;
  display: -ms-flexbox;
  display: flex;
  overflow-x: auto;
  overflow: hidden;
  overflow-y: hidden;
  position: relative;
}
.user-type-wrapper {
  margin-top: 6px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-align: flex-start;
  align-items: flex-start;
  height: 221px;
  overflow: hidden;
}
.user-type-box-heading {
  font-weight: 400;
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 15px;
  letter-spacing: -0.38px;
  color: #3b4e60;
  text-transform: uppercase;
}
.user-type-box {
  padding: 10px;
}
.user-type-detail {
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.07px;
  color: #3b4e60;
  height: 220px !important;
}
.borderBox mat-card {
  border: 2px solid var(--theme-deafult) !important;
}
/*# sourceMappingURL=customer-type-carousel.component.css.map */
